import { TComment } from "apiTypes";
import { AuthContext } from "context/AuthContext";
import { AuthModalContext } from "context/AuthModalContext";
import useTranslation from "next-translate/useTranslation";
import { useContext, useEffect } from "react";
import { arrayFromNum } from "utils/arrayFromNum";
import { DonateDetailsContext } from "../../../context/DonateDetailsContext";
import { DonatePageContext } from "../../../context/DonatePageContext";
import { useInfinitePagination } from "../../../customHooks/useInfinitPagination";
import { baseReactingApiUrl } from "../../../utils/baseReactingApiUrl";
import CommentSkeleton from "../../Skeletons/CommentSkeleton";
import CustomInfinitScroll from "../CustomInfinitScroll";
import MolhamButton from "../MolhamButton";
import NoData from "../NoData";
import Comment from "./Comment";
import EditDeleteCommentDropdown from "./EditDeleteCommentDropdown";

const CommentContainer = ({ isCommentSubmitted }) => {
  const { t } = useTranslation("common");
  const { url } = useContext(DonatePageContext);
  const { donor } = useContext(AuthContext);

  const { handleShowAuthModal, onTabClick } = useContext(AuthModalContext);
  const onSignupBtnClick = () => {
    handleShowAuthModal();
    onTabClick("with_social");
  };
  const { setReactingCounts, setCommentsTab, setReplyTab } =
    useContext(DonateDetailsContext);
  const onCommentsBtnClick = () => {
    if (!donor) {
      onSignupBtnClick();
      return;
    }
    setCommentsTab(true);
  };
  const commentURL = baseReactingApiUrl(url, "comments");

  const {
    hasReachedEnd,
    mutate,
    data,
    formattedData,
    getMoreData,
    error,
    dataLength,
  } = useInfinitePagination<TComment>(
    url ? commentURL : null,
    {
      revalidateOnFocus: true,
      revalidateFirstPage: true,
    },
    null,
    false
  );

  useEffect(() => {
    if (isCommentSubmitted) {
      const mutateCache = async () => {
        await mutate();
        setReactingCounts((prev) => ({
          ...prev,
          comments_count: formattedData.length,
        }));
      };
      mutateCache();
    }
  }, [isCommentSubmitted, dataLength]);

  if (!error && !data) {
    return (
      <>
        {arrayFromNum(4).map((item) => (
          <CommentSkeleton key={item} />
        ))}
      </>
    );
  }
  if (!formattedData.length) {
    return (
      <NoData
        label="nocomments_found"
        actionBtn={{
          label: t("be_the_first_to_comment"),
          onClick: onCommentsBtnClick,
          // icon: "plus",
        }}
      />
    );
  }

  return (
    <div style={{}}>
      <CustomInfinitScroll
        getMoreData={getMoreData}
        dataLength={formattedData?.length}
        hasMore={!hasReachedEnd}
        customLoader={arrayFromNum(4).map((item) => (
          <CommentSkeleton key={item} />
        ))}
        no100vh
      >
        {formattedData?.map((comment, idx) => {
          const isLast = idx === formattedData.length - 1;
          return (
            <>
              <Comment
                isLast={isLast}
                data={comment}
                key={comment?.id}
                hasReplies={comment?.replies && comment?.replies?.length > 0}
                isAdmin={donor?.admin}
                setReplyTab={setReplyTab}
              >
                <EditDeleteCommentDropdown
                  setReactingCounts={setReactingCounts}
                  mutate={mutate}
                  formattedData={formattedData}
                  id={comment?.id}
                />
              </Comment>
              {comment?.replies &&
                comment.replies.map((reply, idx) => {
                  const isLastRep = idx === comment.replies.length - 1;
                  return (
                    <Comment
                      isLast={isLastRep}
                      data={reply}
                      key={reply?.id}
                      isReply
                    >
                      <EditDeleteCommentDropdown
                        setReactingCounts={() => {}}
                        mutate={mutate}
                        formattedData={formattedData}
                        isReply
                        id={reply?.id}
                        commentId={comment?.id}
                      />
                    </Comment>
                  );
                })}
              {/* {idx % 2 === 0 && (
                <>
                  <Comment isLast={isLast} data={comment} isReply>
                    <EditDeleteCommentDropdown
                      setReactingCounts={setReactingCounts}
                      mutate={mutate}
                      formattedData={formattedData}
                      id={comment?.id}
                    />
                  </Comment>
                  <Comment isLast={true} data={comment} isReply />
                </>
              )} */}
            </>
          );
        })}
      </CustomInfinitScroll>
      {formattedData.length ? (
        <div className="d-flex w-100 justify-content-center align-items-center mb-3">
          <MolhamButton
            id="t9-add-comment-btn"
            label={t("add_comment")}
            onClick={onCommentsBtnClick}
            endIcon="fe-plus"
          />
        </div>
      ) : null}
    </div>
  );
};

export default CommentContainer;
